/** Optional PDP tile images; the existing swatch background remains the fallback. */
if (!customElements.get('pdp-image-swatches')) {
  customElements.define('pdp-image-swatches', class extends HTMLElement {
    connectedCallback() {
      this._picker = this.closest('variant-picker');
      this._form = document.forms[this.getAttribute('form')];
      if (!this._picker || !this._form) return;

      try {
        this._data = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      } catch {
        return;
      }

      this._samples = new Map();
      for (const entry of this._data.samples) {
        const key = JSON.stringify([entry.color, entry.material]);
        if (!this._samples.has(key)) {
          this._samples.set(key, entry);
        } else if (this._samples.get(key)?.sample !== entry.sample) {
          // Once a pair conflicts, later entries must not restore an arbitrary image.
          this._samples.set(key, null);
        }
      }

      this._labels = this.parentElement.querySelectorAll('[data-pdp-color-id]');
      this._update = this._update.bind(this);
      this._picker.addEventListener('change', this._update);
      this._form.addEventListener('variant:change', this._update);
      this._update();
    }

    disconnectedCallback() {
      this._picker?.removeEventListener('change', this._update);
      this._form?.removeEventListener('variant:change', this._update);
    }

    _update() {
      let material = '';
      if (this._data.materialPosition) {
        const name = `option${this._data.materialPosition}`;
        // Mobile dropdowns can move into a body-level popover; form association survives.
        const input = this._form.elements.namedItem(name);
        material = this._data.materialValues.find(value => value.name === input?.value)?.id;
      }

      for (const label of this._labels) {
        const key = JSON.stringify([label.dataset.pdpColorId, material]);
        const image = this._samples.get(key)?.image;
        if (image) {
          label.style.setProperty('--pdp-swatch-image', `url(${JSON.stringify(image)})`);
        } else {
          label.style.removeProperty('--pdp-swatch-image');
        }
      }
    }
  });
}
